export type Product = {
  id: string;
  requesterSku: string;
  supplierSku?: string;
  description: string;
  requestedQuantity: string;
  fulfilledQuantity: string | null;
  requestedDate: string;
  promisedDate: string | null;
  fulfilledDate: string | null;
  lineValue?: number;
};
